import { XmlDocument } from 'xmldoc'

export const xmlUtils = {
  compare: (xml1: string, xml2: string): boolean => {
    try {
      if (!xml1 || !xml2) {
        return false
      }

      const xmlDoc1 = new XmlDocument(xml1)
      const xmlDoc2 = new XmlDocument(xml2)

      const str1 = xmlDoc1.toString({ compressed: true })
      const str2 = xmlDoc2.toString({ compressed: true })

      return str1 === str2
    } catch (error) {
      // silent failure assumption is that the xml is not valid
      return false
    }
  },
}
